import * as stylex from '@stylexjs/stylex';
import { LogoTile } from '~components/Logo';
import { legalPaths } from '~pages/Legal/entity';
import { styles } from './styles';

// Washington's My Health My Data Act requires the consumer-health-data notice to
// be a "separate and distinct" homepage link — so the Biometric & Consumer Health
// Data Notice is listed here in its own right, never nested under the privacy
// policy. Keep it that way.
//
// Self-contained like SiteHeader (same page-width container), so it spans the
// header's width regardless of how narrow the hosting page's main is — mount
// it outside <main>.
export function SiteFooter({
  lang = 'en'
}: {
  lang?: 'en' | 'es';
}) {
  const es = lang === 'es';
  return <div {...stylex.props(styles.container)}>
      <footer {...stylex.props(styles.footer)}>
      <div {...stylex.props(styles.brand)}>
        <LogoTile size={32} />
        <span {...stylex.props(styles.brandText)}>
          © {new Date().getFullYear()} Tribys LLC — Get Out There, Come find your tribe.
        </span>
      </div>
      <a href={es ? legalPaths.privacyEs : legalPaths.privacy} {...stylex.props(styles.link)}>
        {es ? 'Aviso de Privacidad' : 'Privacy Policy'}
      </a>
      <a href={es ? legalPaths.biometricEs : legalPaths.biometric} {...stylex.props(styles.link)}>
        {es ? 'Datos Biométricos y de Salud' : 'Biometric & Consumer Health Data'}
      </a>
      <a href={es ? legalPaths.termsEs : legalPaths.terms} {...stylex.props(styles.link)}>
        {es ? 'Términos del Servicio' : 'Terms of Service'}
      </a>
      <a href={es ? legalPaths.guidelinesEs : legalPaths.guidelines} {...stylex.props(styles.link)}>
        {es ? 'Normas de la Comunidad' : 'Community Guidelines'}
      </a>
      </footer>
    </div>;
}